import { render, staticRenderFns } from "./EcommerceRevenueReport.vue?vue&type=template&id=be64f2fe"
import script from "./EcommerceRevenueReport.vue?vue&type=script&lang=js"
export * from "./EcommerceRevenueReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports